<template>
<Form
	class="m-0 p-0 g-0"
	@submit="onSubmit"
	@invalid-submit="console.log"
	:validation-schema="schema"
	:initial-values="formValues"
	v-slot="{ meta, isSubmitting }"
>
<fieldset :disabled="!isFormEnabled">
	<div style="display: none;">
		{{ formMeta = meta }}
		{{ isSubmittingForm = isSubmitting }}
	</div>

	<div class="form-row row m-0 p-0 g-3">
		<div class="col-12 col-xl-6">
			<Field
				:name="Station.passportKeys.autobuildMonthReport"
				type="checkbox"
				id="autobuild-month-report"
				class="form-check-input col-auto"
				:value="true"
				:uncheckedValue="false"
			/>
			<label for="autobuild-month-report" class="form-check-label mx-2 my-0 col-auto">
				{{ Station.settingNames[Station.passportKeys.autobuildMonthReport] }}
			</label>
		</div>

		<div class="col-12 col-xl-6">
			<div class="bg-body border-radius px-3 py-2">
				<p class="form-text fst-italic paragraph-indent">
					Звіт формується кожного 1-го числа місяця з 00:00 до 03:00 годин. Завдання на створеня звіту буде відображено у вкладці звітів станції як завдання від Системи.
				</p>
			</div>
		</div>
	</div>

	<div class="row form-row m-0 p-0 mt-2">
		<p :class="feedbackPromtClass">
			{{ feedbackPromt }}&nbsp;
		</p>
	</div>

	<div class="row form-row m-0 p-0 mt-1 mb-3">
		<div class="form-group col-auto me-0">
			<button
				ref="submitButtonRef"
				type="submit"
				class="btn btn-primary btn-sm"
				:disabled="!meta.valid || !meta.dirty || isSubmitting"
			>
				Записати
			</button>
		</div>
	</div>

	<!-- <pre>Values: {{ values }}</pre>
	<pre>Errors: {{ errors }}</pre>
	<pre>{{ console.log('Meta', meta) }}Meta: <br> touched: {{ meta.touched }} <br> pending: {{ meta.pending }} <br> valid: {{ meta.valid }} <br> dirty: {{ meta.dirty }} </pre> -->
</fieldset>
</Form>
</template>




<script>
import { useStationsStore } from '@/stores/StationsStore.js'
import { useAccontStore } from '@/stores/AccountStore.js'

// Validation
// https://jasonwatmore.com/post/2020/10/01/vue-3-veevalidate-form-validation-example
import { Form, Field } from 'vee-validate'
// https://github.com/jquense/yup/tree/a58f02d2f6164c46a9757a818eebac582f7a441c#boolean
import * as Yup from 'yup';

import { Station } from '@/models/station'
import {
	parseTimeDate,
} from '@/api/api.js'
import {
	capitalizeFirstLetter,
	dateTimeToString,
} from '@/helpers.js'


export default {
	requiredPromt: 'Обов\'язкове поле',
	overMinLenPromt: 'Довжина меньше мінімальної',
	overMaxLenPromt: 'Довжина більше максимальної',
	overMinPromt: 'Значення меньше мінімального',
	overMaxPromt: 'Значення більше максимального',
	onlyIntegersPromt: 'Має бути цілим числом',
	onlyPositivePromt: 'Має бути натуральним числом',
	wrongInputPromt: 'Не відповідає вимогам',

	components: {
		Form,
        Field,
	},

	props: {
		stationId: {
			type: String,
			require: true,
		},
	},

	emits: {
		saveFunction: (f) => typeof f === 'function',
		saveFunctionActive: (f) => typeof f === 'boolean',
	},

	setup() {
		const stationsStore = useStationsStore()
		const accountStore = useAccontStore()

		return {
			stationsStore,
			accountStore,
			Station,
			capitalizeFirstLetter,
			parseTimeDate,
			dateTimeToString,
		}
	},

	data() {
		const schema = Yup.object().shape({
			[Station.passportKeys.autobuildMonthReport]: Yup.boolean()
				.default(false),
		})

		return {
			// Form
			schema,
			formMeta: {},
			isSubmittingForm: false,

			// Feedback promt
			feedbackPromtClass: '',
			feedbackPromt: '',
		}
	},

	watch: {
		formMeta(newMeta) {
			if (newMeta) {
				this.$emit('saveFunctionActive', newMeta.valid && newMeta.dirty && !this.isSubmittingForm);
				// console.log('meta change', newMeta, !newMeta.valid || !newMeta.dirty || this.isSubmittingForm)
			}
		},
	},

	created() {},

	mounted() {
		// Emit function
		this.$emit('saveFunction', this.submitButtonClick)
	},

	methods: {
		onSubmit(values) {
			// Add curent user as passport updator
			values[Station.passportKeys.updateBy] = this.accountStore.userId

			this.stationsStore.updatePasport(
				(result) => {
					if (result) {
						this.printHint('Паспорт успішно оновлено.')
						// Update passport
						this.stationsStore.readPassport(
							undefined,
							this.stationId
						)
					} else {
						this.printErr('Сервер відхилив запит.')
					}
				},
				this.stationId,
				values,
			)
		},

		submitButtonClick() {
			this.$refs.submitButtonRef.click()
		},

		printHint (msg) {
			this.feedbackPromtClass = "text-success"
			this.feedbackPromt = msg
		},

		printErr (msg) {
			this.feedbackPromtClass = "text-danger"
			this.feedbackPromt = msg
		},
	},

	computed: {
		station() { return this.stationsStore.station(this.stationId) },

		isFormEnabled() { return this.accountStore.permissions.includes('manage_stations') },

		formValues() {
			return {
				[Station.passportKeys.autobuildMonthReport]: this.station?.passport.get(Station.passportKeys.autobuildMonthReport),
			}
		},
	},
}
</script>




<style scoped>
/* Remove arrows from input Chrome, Safari, Edge, Opera */
input.no-arrow::-webkit-outer-spin-button,
input.no-arrow::-webkit-inner-spin-button {
	-webkit-appearance: none;
	margin: 0;
}

/* Remove arrows from input Firefox */
input[type=number].no-arrow {
	appearance: textfield;
	-moz-appearance: textfield;
}

.input-min-width {
	min-width: 43ch; 
	max-width: 56ch;
	width: 100%;
}

/* Style for input if it is not match register value */
.not-match-register {
	border-color: rgb(11, 94, 215);
	color: rgb(11, 94, 215);
}
</style>